import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Ruler
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEuMyA4LjcgOC43IDIxLjNjLTEgMS0yLjUgMS0zLjQgMGwtMi42LTIuNmMtMS0xLTEtMi41IDAtMy40TDE1LjMgMi43YzEtMSAyLjUtMSAzLjQgMGwyLjYgMi42YzEgMSAxIDIuNSAwIDMuNFoiIC8+CiAgPHBhdGggZD0ibTcuNSAxMC41IDIgMiIgLz4KICA8cGF0aCBkPSJtMTAuNSA3LjUgMiAyIiAvPgogIDxwYXRoIGQ9Im0xMy41IDQuNSAyIDIiIC8+CiAgPHBhdGggZD0ibTQuNSAxMy41IDIgMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/ruler
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Ruler = createLucideIcon('Ruler', [
  [
    'path',
    {
      d: 'M21.3 8.7 8.7 21.3c-1 1-2.5 1-3.4 0l-2.6-2.6c-1-1-1-2.5 0-3.4L15.3 2.7c1-1 2.5-1 3.4 0l2.6 2.6c1 1 1 2.5 0 3.4Z',
      key: '14xb44',
    },
  ],
  ['path', { d: 'm7.5 10.5 2 2', key: '3h1c69' }],
  ['path', { d: 'm10.5 7.5 2 2', key: '1lvsmz' }],
  ['path', { d: 'm13.5 4.5 2 2', key: '1i616n' }],
  ['path', { d: 'm4.5 13.5 2 2', key: '16iojn' }],
]);

export default Ruler;
